import { useMemo } from "react";
import SelectTemplate from ".";
import { useVisible } from "../../../../../../../../../utils/hooks/useVisible";

export const useSelectTemplate = ({ submit }: { submit: (value: string | undefined) => Promise<boolean | void> }) => {
    const { visible, open, close } = useVisible();

    const modal = useMemo(() => {
        return (
            <SelectTemplate
                visible={visible}
                close={close}
                submit={submit}
            />
        );
    }, [visible, close, submit]);

    return { open, modal };
}